'use client';

import { PageSalesPageSchema } from '@/sanity/pages/PageSalesPageTemplate';
import Footer from '../global/partials/Footer';
import { PortableTextBlock } from 'next-sanity';
import Hero from '../pageComponents/salesPage/Hero';
import FAQDetailsSection from '../pageComponents/salesPage/FAQSection';
import FAQSection from '../pageComponents/global/FAQSection';
import LastSection from '../pageComponents/salesPage/LastSection';
import StickyBottomButton from '../pageComponents/salesPage/StickyBottomButton';
import Meaning from '../pageComponents/salesPage/Meaning';
import Philosophy from '../pageComponents/salesPage/Philosophy';
import HeartRignsSection from '../pageComponents/salesPage/HeartRignsSection';
import BigWatchSection from '../pageComponents/salesPage/BigWatchSection';
import AboutWatch from '../pageComponents/salesPage/AboutWatch';
import PrinceptorSection from '../pageComponents/salesPage/PrinceptorSection';
import MinsterBezelSection from '../pageComponents/salesPage/MinsterBezelSection';
import ArchitetureSection from '../pageComponents/salesPage/ArchitetureSection';
import DesignedSection from '../pageComponents/salesPage/DesignedSection';
import FirstOrderSection from '../pageComponents/salesPage/FirstOrderSection';
import PriceSection from '../pageComponents/salesPage/PriceSection';

export default function PageSalesPageJSX({
  data,
}: {
  data: PageSalesPageSchema;
}) {
  // Note: page_view / Active on Site is automatically tracked by Klaviyo script
  // The _kx parameter is automatically captured for attribution
  // No need to manually track - would create duplicates

  return (
    <main>
      <section className="relative lg:pb-[9rem]">
        <Hero
          heroStickyButton={data?.hero?.heroStickyButton}
          textPreTitle={data?.hero?.textPreTitle}
          glassLabel={data?.hero?.glassLabel}
          label={data?.hero?.label}
          title={data?.hero?.title as PortableTextBlock[]}
          useVideo={data?.hero?.useVideo}
          backgroundVideo={data?.hero?.backgroundVideo}
          backgroundVideoMobile={data?.hero?.backgroundVideoMobile}
        />

        {!data?.firstOrderSection?.hideSection && (
          <FirstOrderSection
            label1={data?.firstOrderSection?.label1}
            label2={data?.firstOrderSection?.label2}
            title={data?.firstOrderSection?.title}
            ctaButton1={data?.firstOrderSection?.ctaButton1}
            ctaButton2={data?.firstOrderSection?.ctaButton2}
          />
        )}

        <div>
          <DesignedSection
            title={data?.designedSection?.title}
            description={data?.designedSection?.description}
            ctaButton1={data?.firstOrderSection?.ctaButton1}
            ctaButton2={data?.firstOrderSection?.ctaButton2}
          />
          <StickyBottomButton data={data?.stickyButton?.stickyButton} textPreTitle={data?.stickyButton} className="hidden lg:block" />
        </div>

        <ArchitetureSection
          title={data?.architetureSection?.title}
          image={data?.architetureSection?.image}
          imageMobile={data?.architetureSection?.imageMobile}
          button={data?.architetureSection?.ctaButton}
        />

        <div>
          <MinsterBezelSection
            image={data?.minsterBezelSection?.image}
            title={data?.minsterBezelSection?.title}
          />
          <StickyBottomButton data={data?.stickyButton?.stickyButton} textPreTitle={data?.stickyButton} />
        </div>

        <PrinceptorSection
          image={data?.princeptorSection?.image}
          title={data?.princeptorSection?.title}
          button={data?.princeptorSection?.button}
          buttonMobile={data?.princeptorSection?.buttonMobile}
        />

        <AboutWatch
          title1={data?.aboutWatch?.title1}
          image={data?.aboutWatch?.image}
          title2={data?.aboutWatch?.title2}
          button={data?.aboutWatch?.ctaButton}
          buttonMobile={data?.aboutWatch?.ctaButtonMobile}
        />

        <div>
          <BigWatchSection
            title={data?.bigWatchSection?.title}
            image={data?.bigWatchSection?.image}
            imageMobile={data?.bigWatchSection?.imageMobile}
          />
          <StickyBottomButton data={data?.stickyButton?.stickyButton} textPreTitle={data?.stickyButton} />
        </div>

        <HeartRignsSection
          image={data?.heartRignsSection?.image}
          imageMobile={data?.heartRignsSection?.imageMobile}
          title={data?.heartRignsSection?.title}
          button={data?.heartRignsSection?.button}
          buttonMobile={data?.heartRignsSection?.buttonMobile}
        />

        <Philosophy
          label={data?.philosophy?.label}
          name={data?.philosophy?.name}
          title={data?.philosophy?.title}
          description={data?.philosophy?.description}
          image={data?.philosophy?.image}
          button={data?.philosophy?.button}
          buttonMobile={data?.philosophy?.buttonMobile}
        />

        <PriceSection
          imageType={data?.priceSection?.imageType}
          image={data?.priceSection?.image}
          textPreTitle={data?.priceSection?.textPreTitle}
          title={data?.priceSection?.title}
          price={data?.priceSection?.price}
          labels={data?.priceSection?.labels}
          button={data?.priceSection?.button}
        />

        <div>
          <FAQDetailsSection
            title={data?.faqDetails?.title}
            faqs={data?.faqDetails?.faqs}
          />
          <StickyBottomButton data={data?.stickyButton?.stickyButton} textPreTitle={data?.stickyButton} />
        </div>

        <div>
          <Meaning
            title={data?.meaning?.title}
            cards={data?.meaning?.cards}
            backgroundVideo={data?.meaning?.backgroundVideo}
            text={data?.meaning?.text}
          />
          <StickyBottomButton data={data?.stickyButton?.stickyButton} textPreTitle={data?.stickyButton} />
        </div>

        <LastSection
          title={data?.lastSection?.title as { lineOne: PortableTextBlock[]; lineTwo: PortableTextBlock[] }}
          titleMobile={data?.lastSection?.titleMobile as PortableTextBlock[]}
          button={data?.lastSection?.ctaButton}
          buttonMobile={data?.lastSection?.ctaButtonMobile}
          backgroundImage={data?.lastSection?.backgroundImage}
        />

        <div>
          <FAQSection
            title={data?.faq?.title}
            faqs={data?.faq?.faqs}
          />
          <StickyBottomButton data={data?.stickyButton?.stickyButton} textPreTitle={data?.stickyButton} />
        </div>

        {data?.settings?.footer && <Footer data={data?.settings?.footer} />}
      </section>
    </main>
  );
}
